// ---------------------------------------------------------------------------
// Primitive helpers
// ---------------------------------------------------------------------------
function isNonNullObject(v) {
    return typeof v === 'object' && v !== null;
}
function isFiniteNumber(v) {
    return typeof v === 'number' && Number.isFinite(v);
}
function isString(v) {
    return typeof v === 'string';
}
function isArray(v) {
    return Array.isArray(v);
}
// ---------------------------------------------------------------------------
// validateDevice
// ---------------------------------------------------------------------------
export function validateDevice(input) {
    if (!isNonNullObject(input)) {
        return { ok: false, error: 'device is not a non-null object' };
    }
    if (!isFiniteNumber(input['id'])) {
        return { ok: false, error: 'device.id is not a finite number' };
    }
    if (!isString(input['hash'])) {
        return { ok: false, error: 'device.hash is not a string' };
    }
    if (!isArray(input['displays'])) {
        return { ok: false, error: 'device.displays is not an array' };
    }
    const displays = input['displays'];
    for (let i = 0; i < displays.length; i++) {
        const display = displays[i];
        const prefix = `device.displays[${i}]`;
        if (!isNonNullObject(display)) {
            return { ok: false, error: `${prefix} is not a non-null object` };
        }
        if (!isFiniteNumber(display['id'])) {
            return { ok: false, error: `${prefix}.id is not a finite number` };
        }
        if (typeof display['name'] !== 'string') {
            return { ok: false, error: `${prefix}.name is not a string` };
        }
        if (typeof display['active'] !== 'boolean') {
            return { ok: false, error: `${prefix}.active is not a boolean` };
        }
        if (display['screens'] !== undefined && !isArray(display['screens'])) {
            return { ok: false, error: `${prefix}.screens is present but not an array` };
        }
    }
    return { ok: true, value: input };
}
// ---------------------------------------------------------------------------
// validateEventListResponseForAllDisplays
// ---------------------------------------------------------------------------
export function validateEventListResponseForAllDisplays(input) {
    if (!isNonNullObject(input)) {
        return { ok: false, error: 'eventList is not a non-null object' };
    }
    if (!isArray(input['event_lists'])) {
        return { ok: false, error: 'eventList.event_lists is not an array' };
    }
    const eventLists = input['event_lists'];
    for (let i = 0; i < eventLists.length; i++) {
        const el = eventLists[i];
        const elPrefix = `event_lists[${i}]`;
        if (!isNonNullObject(el)) {
            return { ok: false, error: `${elPrefix} is not a non-null object` };
        }
        if (!isFiniteNumber(el['id'])) {
            return { ok: false, error: `${elPrefix}.id is not a finite number` };
        }
        if (!isString(el['generated_at'])) {
            return { ok: false, error: `${elPrefix}.generated_at is not a string` };
        }
        if (!isArray(el['display_ids'])) {
            return { ok: false, error: `${elPrefix}.display_ids is not an array` };
        }
        const displayIds = el['display_ids'];
        for (let j = 0; j < displayIds.length; j++) {
            if (!isFiniteNumber(displayIds[j])) {
                return { ok: false, error: `${elPrefix}.display_ids[${j}] is not a finite number` };
            }
        }
        if (!isArray(el['items'])) {
            return { ok: false, error: `${elPrefix}.items is not an array` };
        }
        const items = el['items'];
        for (let j = 0; j < items.length; j++) {
            const item = items[j];
            const itemPrefix = `${elPrefix}.items[${j}]`;
            if (!isNonNullObject(item)) {
                return { ok: false, error: `${itemPrefix} is not a non-null object` };
            }
            if (!isFiniteNumber(item['id'])) {
                return { ok: false, error: `${itemPrefix}.id is not a finite number` };
            }
            if (!isString(item['from'])) {
                return { ok: false, error: `${itemPrefix}.from is not a string` };
            }
            if (!isString(item['to'])) {
                return { ok: false, error: `${itemPrefix}.to is not a string` };
            }
            if (!isFiniteNumber(item['playable_id'])) {
                return { ok: false, error: `${itemPrefix}.playable_id is not a finite number` };
            }
            if (item['is_spot'] !== undefined && item['is_spot'] !== null && typeof item['is_spot'] !== 'boolean') {
                return { ok: false, error: `${itemPrefix}.is_spot is present but not a boolean` };
            }
        }
    }
    if (!isArray(input['playables'])) {
        return { ok: false, error: 'eventList.playables is not an array' };
    }
    const playables = input['playables'];
    for (let i = 0; i < playables.length; i++) {
        const playable = playables[i];
        const pPrefix = `playables[${i}]`;
        if (!isNonNullObject(playable)) {
            return { ok: false, error: `${pPrefix} is not a non-null object` };
        }
        if (!isFiniteNumber(playable['id'])) {
            return { ok: false, error: `${pPrefix}.id is not a finite number` };
        }
        if (!isString(playable['type'])) {
            return { ok: false, error: `${pPrefix}.type is not a string` };
        }
        if (!isArray(playable['medias'])) {
            return { ok: false, error: `${pPrefix}.medias is not an array` };
        }
    }
    return { ok: true, value: input };
}
//# sourceMappingURL=index.js.map